import React, { useState, useEffect } from 'react'
import { Panel, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'

export default function HistoryChangeSubProjectStatusWidget({
  schema: _schema,
  loading,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    setTableData(formSchema?.dataVal || [])
  }, [formSchema])

  return (
    <Panel shaded header={formSchema.header} eventKey={2} collapsible defaultExpanded>
      <Table
        wordWrap
        // height={350}
        // autoHeight={tableData.length < 10}
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData}
        style={{ marginTop: 10 }}
      >
        <Column width={90} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        {formSchema?.dataVal[0]?.requestDescriptionLabel && (
          <Column width={250} resizable>
            <HeaderCell>{formSchema?.dataVal[0]?.requestDescriptionLabel}</HeaderCell>
            <Cell dataKey="requestDescription" />
          </Column>
        )}
        {formSchema?.dataVal[0]?.requestDateLabel && (
          <Column width={200} resizable>
            <HeaderCell>{formSchema?.dataVal[0]?.requestDateLabel}</HeaderCell>
            <Cell dataKey="requestDate" />
          </Column>
        )}
        {formSchema?.dataVal[0]?.approveDescriptionLabel && (
          <Column width={250} resizable>
            <HeaderCell>{formSchema?.dataVal[0]?.approveDescriptionLabel}</HeaderCell>
            <Cell dataKey="approveDescription" />
          </Column>
        )}
        {formSchema?.dataVal[0]?.approvedByLabel && (
          <Column width={200} resizable>
            <HeaderCell>{formSchema?.dataVal[0]?.approvedByLabel}</HeaderCell>
            <Cell dataKey="approvedBy" />
          </Column>
        )}
        {formSchema?.dataVal[0]?.approvedDateLabel && (
          <Column width={200} resizable>
            <HeaderCell>{formSchema?.dataVal[0]?.approvedDateLabel}</HeaderCell>
            <Cell dataKey="approvedDate" />
          </Column>
        )}

        {formSchema?.dataVal[0]?.statusLabel && (
          <Column width={200} resizable>
            <HeaderCell>{formSchema?.dataVal[0]?.statusLabel}</HeaderCell>
            <Cell dataKey="status" />
          </Column>
        )}
      </Table>
    </Panel>
  )
}
